module.exports = __webpack_public_path__ + "static/media/gameLogo.2d540199.png";